import AccountRowElement from './AccountRow.jsx';

export default AccountRowElement;
